import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m19.51 5.85-5.94-3.43c-.97-.56-2.17-.56-3.15 0L4.49 5.85a3.15 3.15 0 0 0-1.57 2.73v6.84c0 1.12.6 2.16 1.57 2.73l5.94 3.43c.97.56 2.17.56 3.15 0l5.93-3.43a3.15 3.15 0 0 0 1.57-2.73V8.58c0-1.13-.6-2.17-1.57-2.73m-8.26 1.9c0-.41.34-.75.75-.75s.75.34.75.75V13c0 .41-.34.75-.75.75s-.75-.34-.75-.75zm1.67 8.88q-.075.18-.21.33a.99.99 0 0 1-1.09.21c-.13-.05-.23-.12-.33-.21q-.135-.15-.21-.33c-.03-.12-.03-.25-.03-.38 0-.26.15-.51.34-.71.1-.09.2-.16.23-.21.37-.16.81-.07 1.09.21.09.1.16.21.21.34a1.209 1.209 0 0 1 0 .75" }, null, -1)
  ]))]))
}
export default { render: render }